module.exports = __webpack_public_path__ + "img/icon_fax.d5bbc314.png";